
// import tubitakLogo from "../assets/images/logo/TÜBİTAK_logo.svg";
import { MdOutlineMail } from "react-icons/md";
import { GiPathDistance } from "react-icons/gi";

const Footer = () => {
  return (
    <footer>
      <div id="footer-content">
        {/* <a href="https://atauni.edu.tr" target="_blank" rel="noreferrer">
                    <img src={atauniLogo} alt="atauniLogo" className="atauni-logo"/>
                </a> */}
        <div id="footer-inner-content">
          <div id="footer-left">
            <h5>Hızlı Linkler</h5>
            <ul>
              <li>
                <a
                  href="https://forms.gle/oVUHswNcQ8uonqaT8"
                  target="_blank"
                  rel="noreferrer"
                >
                  Başvuru ve Ayrıntılar
                </a>
              </li>
              <li>
                <a
                  href="https://www.atauni.edu.tr/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Atatürk Üniversitesi
                </a>
              </li>
              <li>
                <a
                  href="https://tubitak.gov.tr/tr/destekler/bilimsel-etkinlik/etkinlik-duzenleme-destekleri/2237-bilimsel-egitim-etkinlikleri-destegi"
                  target="_blank"
                  rel="noreferrer"
                >
                  Tübitak 2237-A
                </a>
              </li>
            </ul>
          </div>
          <div id="footer-right">
            <h5>İletişim</h5>
            <ul>
              <li>
                <span>
                  <MdOutlineMail />
                </span>{" "}
                <span className="title-span">E-Posta:</span>{" "}
                <a href="mailto:ataunihemsirelik2237a@gmail.com">
                  ataunihemsirelik2237a@gmail.com
                </a>
              </li>
              <li>
                <span>
                  <GiPathDistance />
                </span>{" "}
                <span className="title-span">Adres:</span>{" "}
                <span className="content-span">
                  Atatürk Üniversitesi Merkez Kampüsü Prof. Dr. Ali Ertuğrul
                  Caddesi Dış Kapı No :2
                </span>
              </li>
            </ul>
          </div>
        </div>
        <a href="https://tubitak.gov.tr" target="_blank" rel="noreferrer">
          {/* <img src={tubitakLogo} alt="tubitakLogo" /> */}
        </a>
      </div>
      <p id="copyright-notice">© 2026, Tüm hakları saklıdır.</p>
    </footer>
  );
};

export default Footer;
